export default function MemoryCascade({ question, taskState, onChoiceClick }) {
  const tState = taskState || {};
  const found = tState.found || []; // Теперь это массив объектов
  const missed = tState.missed || [];
  const phase = tState.phase || 'free';
  const missIdx = tState.missIdx || 0;

  return (
    <div className="flex flex-col items-center gap-8 w-full max-w-5xl">
      <div className="grid grid-cols-5 gap-4 w-full">
        {question.words.map((wObj, i) => {
          // НОВОЕ: Ищем слово в массиве объектов
          const foundObj = found.find(f => f.word === wObj.word);
          const isFound = !!foundObj;
          return (
            <div key={i} className={`border-2 rounded-2xl flex items-center justify-center h-32 ${isFound ? 'bg-green-500/20 border-green-500' : 'bg-secondary border-border'}`}>
              {isFound ? <span className="text-2xl font-bold text-green-600 capitalize">{wObj.word}</span> : <span className="text-4xl text-muted-foreground/50">?</span>}
            </div>
          );
        })}
      </div>
      
      {phase === 'choices' && missed.length > 0 && (
        <div className="flex flex-col items-center gap-4 w-full">
          <h3 className="text-xl font-bold text-primary">Варианты ответов</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 w-full max-w-3xl mx-auto">
            {question.words.find(w => w.word === missed[missIdx])?.choices.map((choice) => (
              <button key={choice} onClick={() => onChoiceClick(choice)} className="bg-secondary border-2 border-border rounded-2xl px-6 py-5 text-2xl md:text-3xl font-semibold text-primary hover:bg-accent/10 hover:border-accent transition-colors">
                {choice}
              </button>
            ))}
        </div>  
        </div>
      )}
    </div>
  );
}